import React, { useRef, useState } from "react";
import "./ohjeet-ja-apua.m.css";

const OhjeetApua = () => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show)
  const faqsRef = useRef(null);
  const verkkosivustonkaytto = useRef(null);
  const scrollToFAQs = () => {
    faqsRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToKaytto = () => {
    verkkosivustonkaytto.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div styleName="container">
      <div styleName="hero-image">
        <img src="https://s3-alpha-sig.figma.com/img/1c4c/1c56/077c2920d9ec8655d049089c2dfacbc7?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dG6Kpz7yVoaNo4Xqy0f~Zu-YtharChBXABuKbes3TgZwcP~mkvxCeaaex5IesfogwariSqGsTKGdpeHwW2nBJmzm0ZHLRjtTsEKkKUq7vcu69Nxva9~fXL1EZ68PXfl0j332mspOqULI57~zbGXa-~kmf40fq631-v3SLbq4BoUbLj5zjXadGFp0G-fA5c2XMg2Dn0obIbafLT0hqVUWtKST3QEGdbogMiF-f0APZbKDEJYuOC2vURfNCxkwy4hRvYN-FQYW52uCc4BHlpFCQ~LoroQkHZaGXqnhHb~wTf6W3j7cfNWpj01HCtMTLKPZCKpn3R71mq9NTsigVulloA__" />
        <div styleName="header-one">
          <h2>Ohjeet ja apua</h2>
          <p>
            Tervetuloa Radio Dein ohje- ja tukisivulle. Täältä löydät vastauksia yleisimpiin kysymyksiin, teknistä tukea
            ja apua radiokanavan kuunteluun liittyvissä asioissa.
          </p>
          <div styleName="overlay-btns">
            <button onClick={scrollToKaytto}>Verkkosivuston käyttö</button>
            <button onClick={scrollToFAQs}>FAQs</button>
          </div>
        </div>
      </div>

      <div ref={verkkosivustonkaytto} styleName="web-usage-instructions">
        <h2>Verkkosivuston käyttöohjeet</h2>
        <p>
          Radio Dein verkkosivusto (www.radiodei.fi) tarjoaa monipuolisia ominaisuuksia kuuntelukokemuksesi
          parantamiseksi. Seuraa näitä yksinkertaisia ohjeita navigoidaksesi ja käyttääksesi kaikkia verkkosivuston
          ominaisuuksia tehokkaasti.
        </p>
      </div>


      <div styleName="container-listing">
        <h2>Suoran lähetyksen kuuntelu verkkosivustolla</h2>
        <div styleName="list-item">
            <div styleName="number">1</div>
            <div styleName="text">
                <h3>Siirry Radio Dein verkkosivustolle</h3>
                <p>Avaa verkkoselaimesi ja mene osoitteeseen <a href="https://www.radiodei.fi">www.radiodei.fi</a></p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">2</div>
            <div styleName="text">
                <h3>Paikanna suoratoistosoitin</h3>
                <p>Etsi "Kuuntele suorana" -painike kotisivun yläosasta.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">3</div>
            <div styleName="text">
                <h3>Napsauta aloittaaksesi kuuntelun</h3>
                <p>Napsauta "Kuuntele suorana" -painiketta ja suoratoisto alkaa.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">4</div>
            <div styleName="text">
                <h3>Säädä äänenvoimakkuutta ja asetuksia</h3>
                <p>Käytä soittimen säätimiä äänenvoimakkuuden säätämiseen.</p>
            </div>
        </div>
    </div>



    <div styleName="text-vinkki">
    <div styleName="number">4</div>
      <h3><strong>Vinkki:</strong>
     Parhaan kuuntelukokemuksen saamiseksi varmista, että laitteesi ääni on päällä ja asetettu sopivalle tasolle. Jos käytät kuulokkeita, kytke ne ennen toiston aloittamista.
      </h3>
    </div>



      <div styleName="container-listing">
        <h2>Ohjelmatietojen etsiminen</h2>
        <div styleName="list-item">
            <div styleName="number">1</div>
            <div styleName="text">
                <h3>Siirry Ohjelmat-osioon</h3>
                <p>Napsauta verkkosivuston yläosan päänavigointivalikossa olevaa "Ohjelmat"-kohtaa.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">2</div>
            <div styleName="text">
                <h3>Paikanna suoratoistosoitin</h3>
                <p>Viikkoaikataulu näytetään kalenterimuodossa. Voit navigoida päivien välillä kalenterin yläosassa olevien välilehtien avulla.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">3</div>
            <div styleName="text">
                <h3>Katso yksityiskohtaisia ohjelmatietoja</h3>
                <p>Napsauta mitä tahansa ohjelmaa aikataulussa nähdäksesi yksityiskohtaiset tiedot, mukaan lukien kuvaukset, juontajat ja jaksotiedot.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">4</div>
            <div styleName="text">
                <h3>Etsi tiettyjä ohjelmia</h3>
                <p>Käytä verkkosivuston oikeassa yläkulmassa olevaa hakutoimintoa löytääksesi tiettyjä ohjelmia nimen tai aiheen perusteella.</p>
            </div>
        </div>
    </div>



      <div styleName="container-listing">
        <h2>Podcast-kirjaston käyttäminen</h2>
        <div styleName="list-item">
            <div styleName="number">1</div>
            <div styleName="text">
                <h3>Siirry Ohjelmat-osioon</h3>
                <p>Napsauta päänavigointivalikossa olevaa "Podcastit"-kohtaa päästäksesi täydelliseen podcast-kirjastoon.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">2</div>
            <div styleName="text">
                <h3>Selaa podcast-kategorioita</h3>
                <p>Selaa eri kategorioita tai käytä suodattimia löytääksesi podcasteja aiheen, juontajan tai suosion perusteella.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">3</div>
            <div styleName="text">
                <h3>Toista podcast-jakso</h3>
                <p>Napsauta mitä tahansa jaksoa aloittaaksesi toiston. Podcast-soittimen avulla voit keskeyttää, hypätä eteen-/taaksepäin ja säätää toistonopeutta.</p>
            </div>
        </div>
        <div styleName="list-item">
            <div styleName="number">4</div>
            <div styleName="text">
                <h3>Lataa jaksoja</h3>
                <p>Etsi kunkin jakson vieressä oleva latauskuvake tallentaaksesi sen offline-kuuntelua varten. Ladatut jaksot tallennetaan laitteellesi.</p>
            </div>
        </div>
    </div>

    <div styleName="text-vinkki">
    <div styleName="number">4</div>
      <h3><strong>Vinkki:</strong>
      Voit tilata podcast-RSS-syötteitä napsauttamalla tilausikonia minkä tahansa podcast-sarjan sivulla. Tämä mahdollistaa uusien jaksojen vastaanottamisen automaattisesti haluamaasi podcast-sovellukseen.
      </h3>
    </div>



    <div styleName="web-usage-instructions instructions-lower">
        <h2>Usein kysytyt kysymykset</h2>
        <p>
        Vastauksia yleisimpiin Radio Dein kuunteluun ja palveluihin liittyviin kysymyksiin.
        </p>
    </div>


        <div ref={faqsRef} styleName="faqs-wrapper">

          <div styleName="faqs">
              <h3>
              Miksi radio ei kuulu kunnolla alueellani?
              </h3>
              <div styleName="number number-btn"
              onClick={()=>handleToggle()}>+</div>
        </div>
       {show&&
       <><p>
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
          </p><p>
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            </p></>
        }
        </div>

        <div styleName="faqs-wrapper">
          <div styleName="faqs">
              <h3>
              Miksi radio ei kuulu kunnolla alueellani?
              </h3>
              <div styleName="number number-btn"
              onClick={()=>handleToggle()}>+</div>
        </div>

        </div>

        <div styleName="faqs-wrapper">
          <div styleName="faqs">
              <h3>
              Miksi radio ei kuulu kunnolla alueellani?
              </h3>
              <div styleName="number number-btn"
              onClick={()=>handleToggle()}>+</div>
        </div>

        </div>
    </div>
  );
};

export { OhjeetApua };
